<template>
  <b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9">
          <b-row class="border">
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Versiones</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'ModelsListByBrand' }">Modelos</b-link> &raquo; Lista de versiones del modelo {{ model.name.toUpperCase() }} de la marca {{ this.$route.params.slug.toUpperCase() }}:
                  <b-btn size="sm" @click.stop="crear()">Agregar Version para el modelo {{ model.name.toUpperCase() }}</b-btn>
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-table striped hover :items="versions" :fields="fields">
                <template slot="actions" slot-scope="row">
                  <b-btn size="sm" @click.stop="details(row.item)">Ver detalle</b-btn>
                </template>
              </b-table>
              <ul v-if="errors && errors.length">
                <li v-for="(error, index) in errors" :key="index">
                  <b-alert show>{{error.message}}</b-alert>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'
import Menu from './Menu'
export default {
  name: "VersionesByModel",
  components:{
    Header,
    Menu
  },
  data() {
    return {
      fields: {
        name: { label: "Nombre de la Versión", sortable: true, class: "text-left" },
        model: { label: "Modelo", sortable: false, class: "text-center" },
        brand: { label: "Marca", sortable: false, class: "text-center" },
        codigo_sap: { label: "Código SAP", sortable: false, class: "text-center" },
        created_at: {
          label: "Fecha de Ingreso",
          sortable: true,
          class: "text-center"
        },
        actions: { label: "", class: "text-center" }
      },
      versions: [],
      model:[]
    };
  },
  created() {
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/models/` + this.$route.params.model_id)
      .then(response => {
        this.model = response.data
        document.title = "Administración Derco - Oficina " + response.data.name
      })
      .catch(e => {
        this.errors.push(e)
      })

      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
      .get(`/version-brands/` + this.$route.params.model_id)
      .then(response => {
        this.versions = response.data;
      })
      .catch(e => {
        this.errors.push(e);
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    details (version) {
      this.$router.push({
        name: 'ShowVersion',
        params: { id: version._id, slug: version.slug_brand, model: version.model}
      })
    },
    crear () {
      this.$router.push({
        name: 'CreateVersion',
        params: {slug: this.model.slug, model: this.model.name, model_id: this.model._id}
      })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
};
</script>

<style>
.jumbotron {
  padding: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/VersionesByModel.vue